// extracted by mini-css-extract-plugin
module.exports = {"toasters":"styles_toasters__GJ4wZ"};